export default __webpack_public_path__ + "static/media/mandrill.0a7c3eee.svg";